import { useEffect } from 'react'
import type { Portion, Product } from '../../types'
import { portionsOf } from '../../utils/portionPrices'
import { formatTRY } from '../../utils/money'
import { XIcon } from '../icons'
import './ConfirmDialog.css'
import './PortionPicker.css'

/** Rozetteki miktar: "1,5 Porsiyon" → "1,5"; sayı yoksa ilk harf. */
const amountOf = (name: string) => name.match(/\d+(?:[.,]\d+)?/)?.[0] ?? name.trim().charAt(0).toLocaleUpperCase('tr')

interface Props {
  product: Product
  /** null: ürünün kendi fiyatı (1 porsiyon). */
  onPick: (portion: Portion | null) => void
  onClose: () => void
}

/**
 * Porsiyon seçimi (3 Kas 2026, kullanıcı): porsiyonlu ürüne basınca
 * porsiyonlar fiyatıyla çıkar, birine dokununca sepete girer. Esc ve
 * dışına tıklama kapatır.
 */
export function PortionPicker({ product, onPick, onClose }: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault()
        e.stopPropagation()
        onClose()
      }
    }
    window.addEventListener('keydown', onKey, true)
    return () => window.removeEventListener('keydown', onKey, true)
  }, [onClose])

  return (
    <div
      className="dlg"
      role="dialog"
      aria-modal="true"
      aria-label={`${product.name}: porsiyon seç`}
      onMouseDown={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="dlg__card dlg__card--x portion">
        <button type="button" className="dlg__x" onClick={onClose} aria-label="Kapat">
          <XIcon />
        </button>
        <h2>{product.name}</h2>
        <p className="portion__lead">Porsiyon seçin</p>
        <div className="portion__list">
          {portionsOf(product).map((p) => (
            <button
              key={p.name}
              type="button"
              aria-label={`${p.name}, ${formatTRY(p.priceKurus)}`}
              className="portion__opt"
              onClick={() => onPick(p.base ? null : { name: p.name, priceKurus: p.priceKurus })}
            >
              <span className="portion__badge" aria-hidden="true">
                {amountOf(p.name)}
              </span>
              <span className="portion__price">{formatTRY(p.priceKurus)}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
